import { observer } from 'mobx-react-lite';
import { FC, ReactElement } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import { List } from 'APP/components/List/List';
import { PopupUserItem } from 'APP/main/Popups/GetParametersManager/components/PopupUserItem/PopupUserItem';

import { useGroupFormGeneralMembersPresenter } from './GroupFormGeneralMembers.presenter';
import styles from './GroupFormGeneralMembers.styles.m.css';

interface IGroupFormGeneralMembersProps {
  membersIds: string[];
}

export const GroupFormGeneralMembers: FC<IGroupFormGeneralMembersProps> = observer((props) => {
  const { membersIds } = props;
  const { t } = useTranslation();
  const presenter = useGroupFormGeneralMembersPresenter({ membersIds });

  if (!membersIds.length) {
    return null;
  }

  return (
    <div className={styles.members}>
      <div className={styles.membersCount}>
        {`${t('group_chat_members_tab_title')} (${membersIds.length})`}
      </div>
      <List
        data={presenter.members}
        keyExtractor={presenter.keyExtractor}
        renderItem={(contact): ReactElement => <PopupUserItem user={contact} />}
      />
    </div>
  );
});
